import { render, staticRenderFns } from "./regulatoryCategory.vue?vue&type=template&id=774dae05&scoped=true"
import script from "./regulatoryCategory.vue?vue&type=script&lang=js"
export * from "./regulatoryCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774dae05",
  null
  
)

export default component.exports